import { useContext } from 'react';
import { useNavigate } from 'react-router';
import {
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from '@/components/iconify';
import { ProductRatingsContext } from '@/contexts/ProductRatingsContext';

export default function ProductReviewsHeader() {
  const navigate = useNavigate();
  const { title, averageRating, isError } = useContext(ProductRatingsContext);

  const handleBack = () => navigate(-1);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1168,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pb: 2,
      }}
    >
      {/* Linha: Voltar */}
      <Stack
        direction="row"
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <Button
          variant="text"
          onClick={handleBack}
          startIcon={<Iconify icon="ion:arrow-back-outline" />}
          sx={{
            px: 1,
            py: 1,
            gap: 1,
            borderRadius: 1,
            fontFamily: 'Public Sans',
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '24px',
            color: '#0F7864',
            '&:hover': {
              backgroundColor: 'rgba(15, 120, 100, 0.08)',
            },
          }}
        >
          Voltar
        </Button>
      </Stack>

      {/* Título + nota média */}
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="h3"
          sx={{
            fontFamily: 'Public Sans',
            fontWeight: 700,
            fontSize: 24,
            lineHeight: '32px',
            display: 'flex',
            alignItems: 'center',
            color: '#FFFFFF',
          }}
        >
          {title}
        </Typography>

        {/* Média 0.0 numa consulta que falhou se lê como nota ruim, não como falha. */}
        {!isError && averageRating != null && (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 25.28,
                height: 25.28,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#1D845B',
              }}
            >
              <Iconify
                icon="mdi:cactus"
                width={18}
                height={18}
                sx={{ color: '#FFFFFF' }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: 'Public Sans',
                fontWeight: 500,
                fontSize: 18,
                lineHeight: '26px',
                color: '#FFFFFF',
              }}
            >
              {averageRating.toFixed(1)}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
